import { Component, Input } from '@angular/core';
import connectCurrentRefinements from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';
import {
  CONTENT_FILTERS,
  Filter,
  FilterType,
  PRIVACY_FILTERS
} from '../../ALGOLIA_CONFIG';
import { BaseWidget } from '../base-widget';
import { RefinementAttributeItem, RefinementItem } from '../search.types';

interface CurrentRefinementsState {
  items: RefinementAttributeItem[];
  refine: (refinement: RefinementItem) => void;
  canRefine: boolean;
}

@Component({
  selector: 'app-current-refinements',
  templateUrl: './current-refinements.component.html',
  styleUrls: ['./current-refinements.component.scss']
})
export class CurrentRefinementsComponent extends BaseWidget<CurrentRefinementsState> {
  private attributeMap = {};
  public FILTERTYPE = FilterType;

  @Input() showClearAll = true;

  // Optional: exclude specific attributes from display
  @Input() excludedAttributes: string[] = [];

  ngOnInit() {
    super.ngOnInit();
    CONTENT_FILTERS.concat(PRIVACY_FILTERS).forEach(filter => {
      if (filter.name) {
        this.attributeMap[filter.attribute] = filter;
      }
      if (filter.subCategories) {
        filter.subCategories.forEach(subFilter => {
          this.attributeMap[subFilter.attribute] = subFilter;
        });
      }
    });
  }

  private getDate(value: string | number): string {
    const date = new Date(value);
    const yyyy = date.getFullYear().toString();
    let mm = (date.getMonth() + 1).toString();
    let dd = date.getDate().toString();
    if (mm.length < 2) {
      mm = '0' + mm;
    }
    if (dd.length < 2) {
      dd = '0' + dd;
    }
    return `${yyyy}-${mm}-${dd}`;
  }

  createWidget() {
    return connectCurrentRefinements((renderState, isFirstRender) => {
      if (isFirstRender) return;

      const items = this.excludedAttributes.length
        ? renderState.items.filter(
            item => !this.excludedAttributes.includes(item.attribute)
          )
        : renderState.items;

      this.updateState({
        items,
        refine: renderState.refine,
        canRefine: renderState.canRefine
      });
    })({
      transformItems: items => {
        const newItems = items.map(item => {
          const filter: Filter = this.attributeMap[item.attribute];
          let refinements = item.refinements;
          let value = '';
          if (filter.type == FilterType.NumericMenuSelect) {
            value = `0 - ${refinements[0].value}`;
          } else if (filter.type == FilterType.DateRange) {
            value = `${this.getDate(refinements[0].value)} - ${this.getDate(
              refinements[1].value
            )}`;
          } else if (filter.type == FilterType.Menu) {
            value = item.refinements[0].label == 'true' ? 'Yes' : 'No';
          } else {
            refinements = item.refinements.map(ref => {
              return {
                ...ref,
                customLabel: `${filter.name}: ${ref.label}`
              };
            });
          }
          return {
            ...item,
            type: filter.type,
            refinements,
            customLabel: `${filter.name}: ${value}`
          };
        });
        return newItems;
      }
    });
  }

  // Remove all refinements at once
  public clearAll() {
    this.state.items.forEach(item =>
      item.refinements.forEach(refinement => this.state.refine(refinement))
    );
  }

  public customRefine(refinements: any[]) {
    refinements.forEach(refinement => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.state.refine(refinement);
    });
  }
}
